import React from 'react'
import HoneymoonPackages from './HoneymoonPackages.jsx'
import Navber from '../../../Components/Navber.jsx'

function Mainlayout() {
  return (
    <div>
        <Navber/>
        <HoneymoonPackages/>
    </div>
  )
}

export default Mainlayout